import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import "../assets/css/login.css";

function isStrongPassword(pwd) {
  const s = String(pwd || "");
  if (s.length < 12) return false;
  if (!/[0-9]/.test(s)) return false;
  if (!/[A-Z]/.test(s)) return false;
  if (!/[a-z]/.test(s)) return false;
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(s)) return false;
  return true;
}

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const same = useMemo(() => String(p1) === String(p2), [p1, p2]);

  const validate = () => {
    if (!p1 || !p2) return "Completa i campi richiesti";
    if (!isStrongPassword(p1)) {
      return "Password non valida: min 12, 1 numero, 1 maiuscola, 1 minuscola, 1 speciale";
    }
    if (!same) return "Le password non coincidono";
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    const msg = validate();
    if (msg) {
      setError(msg);
      return;
    }

    setSaving(true);
    setError("");
    try {
      await api.post("/api/reset-password", { token, password: p1 });
      navigate("/", { replace: true });
    } catch (err) {
      setError("Dati errati o link scaduto");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="login_container">
      <div className="login_wrapper">
        <div className="logo_container">
          <div className="logo_img" aria-hidden="true" />
          <div className="logo_wrt" aria-hidden="true" />
        </div>

        <div className="login_form">
          <h1>RESETTA PASSWORD</h1>

          <p className="forgot_text">
            Inserisci due volte la nuova password uguale: se coincidono e rispettano i requisiti, potrai resettare e tornare al login.
          </p>

          <form onSubmit={onSubmit} noValidate>
            <div className="input_group">
              <label htmlFor="p1">Nuova Password</label>
              <input
                type="password"
                id="p1"
                name="p1"
                placeholder="Inserisci la nuova password"
                autoComplete="new-password"
                value={p1}
                onChange={(e) => setP1(e.target.value)}
                required
              />
            </div>

            <div className="input_group">
              <label htmlFor="p2">Ripeti Password</label>
              <input
                type="password"
                id="p2"
                name="p2"
                placeholder="Ripeti la password"
                autoComplete="new-password"
                value={p2}
                onChange={(e) => setP2(e.target.value)}
                required
              />
            </div>

            <div className="login_notice_slot">
              {error ? <p className="login_error">{error}</p> : <span className="login_notice">&nbsp;</span>}
            </div>

            <button type="submit" disabled={saving}>
              {saving ? "Salvataggio..." : "Resetta"}
            </button>
          </form>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/", { replace: true });
            }}
          >
            Torna al Login
          </a>
        </div>
      </div>
    </main>
  );
}
